import InventoryWorkbookPage from "../pages/InventoryWorkbookPage";
import ShopInventoryPage from "../pages/ShopInventoryPage";
// src/app/routes.jsx
import CancelledVouchers from "../pages/CancelledVouchers";
import AllShopSalesReport from "../pages/AllShopSalesReport";
import InventoryOverviewPage from "../pages/InventoryOverviewPage";
import ErpInventoryCatalogOverview from "../pages/ErpInventoryCatalogOverview";
import { Routes, Route, Navigate } from "react-router-dom";
import Inventory from "../pages/Inventory";
import NoticeWarningPage from "../pages/NoticeWarningPage";
import DeliveryRatePage from "../pages/DeliveryRatePage";
import DeliveryMarketingPage from "../pages/DeliveryMarketingPage";
import CouponPage from "../pages/CouponPage";
import PromotionPage from "../pages/PromotionPage";
import PromotionGiftHistory from "../pages/PromotionGiftHistory";
import PromotionDiscountHistory from "../pages/PromotionDiscountHistory";
import DeliveryFreeRulesPage from "../pages/DeliveryFreeRulesPage";
import ErpDashboard from "../pages/ErpDashboard";
import VoucherOtpRequestsPage from "../pages/VoucherOtpRequestsPage";
import MemberManagementPage from "../pages/MemberManagementPage";
import WaybillMonitor from "../pages/WaybillMonitor";
import LocationManagementPage from "../pages/LocationManagementPage";
import CashFlow from "../pages/CashFlow";
import CashClosing from "../pages/CashClosing";
import ExpenseCategories from "../pages/ExpenseCategories";
import ExpenseReport from "../pages/ExpenseReport";
import ProfitCostPage from "../pages/ProfitCostPage";
import WarehouseDashboardPage from "../pages/WarehouseDashboardPage";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/erp/dashboard" replace />} />

      <Route path="/erp/dashboard" element={<ErpDashboard />} />
      <Route path="/erp/cash-flow" element={<CashFlow />} />
      <Route path="/erp/cash-closing" element={<CashClosing />} />
      <Route path="/erp/expense-categories" element={<ExpenseCategories />} />
      <Route path="/erp/expense-report" element={<ExpenseReport />} />
      <Route path="/erp/inventory/survey" element={<InventoryWorkbookPage mode="survey" />} />
      <Route path="/erp/inventory/stock-balance" element={<InventoryWorkbookPage mode="balance" />} />
      <Route path="/erp/inventory" element={<ShopInventoryPage />} />
      <Route path="/erp/inventory/shop/:shopCode" element={<ShopInventoryPage view="matrix" />} />
      <Route path="/erp/inventory/negative" element={<ShopInventoryPage view="negative" />} />
      <Route path="/erp/inventory/low-stock" element={<ShopInventoryPage view="low" />} />
      <Route path="/erp/inventory/tools" element={<InventoryOverviewPage />} />
      <Route path="/erp/inventory-catalog" element={<ErpInventoryCatalogOverview />} />
      <Route path="/erp/all-shop-sales" element={<AllShopSalesReport />} />
      <Route path="/erp/cancelled-vouchers" element={<CancelledVouchers />} />
      <Route path="/erp/locations" element={<LocationManagementPage />} />
      <Route path="/erp/waybill" element={<WaybillMonitor />} />
      <Route
        path="/erp/promotion-discount-history"
        element={<PromotionDiscountHistory />}
      />
      <Route path="/erp/notice-warning" element={<NoticeWarningPage />} />
      <Route path="/erp/delivery-rates" element={<DeliveryRatePage />} />
      <Route
  path="/erp/delivery-marketing"
  element={<DeliveryMarketingPage />}
/>
<Route
  path="/erp/delivery-free-rules"
  element={<DeliveryFreeRulesPage />}
/>

      <Route path="/erp/coupons" element={<CouponPage />} />
      <Route path="/erp/members" element={<MemberManagementPage />} />
      <Route path="/erp/voucher-otp-requests" element={<VoucherOtpRequestsPage />} />
      <Route path="/erp/promotions" element={<PromotionPage />} />
      <Route path="/erp/promotion-history" element={<PromotionGiftHistory />} />
<Route path="/erp/profit-cost" element={<ProfitCostPage />} />

      <Route path="/erp/warehouse" element={<WarehouseDashboardPage />} />

      <Route path="*" element={<div>404 Not Found</div>} />
</Routes>
  );
}








